import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

let CustomLateralModal = (props) => {
    return (
        <Modal isOpen={props.isOpen} toggle={props.modalToggle}
            modalClassName="modal right fade" style={{...props.style}}>

            <ModalHeader toggle={props.modalToggle} style={{ minHeight: 65, fontSize: 10 }} tag="h5">
                {props.title}
            </ModalHeader>

            <ModalBody style={{ paddingTop: 0, paddingBottom: 0 }}>
                {props.children}
            </ModalBody>

            <ModalFooter style={{ minHeight: 60 }}>
                {props.footerButtons}
                <Button color="secondary" onClick={props.modalToggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
}

export default CustomLateralModal;